module.exports = __webpack_public_path__ + "img/CloudCase.6bb3a289.png";